export default __webpack_public_path__ + "static/hosting-hero-img-505b11b5de7d765e7bf681666f7d1c27.png";